import { KeycloakServerConfig } from 'keycloak-js';
import { getConfigAsync } from '@core/settings/config-loader';
import { environment as Config } from '@env/environment';

let settings: KeycloakServerConfig | null = null;

/**
 * Indirizzo a cui il server riporta il controllo silenzioso dell'accesso. La pagina che ci sta dietro non fa
 * altro che annunciare l'esito alla finestra padre, quindi il controllo termina in un iframe nascosto e la
 * scheda non viene mai reindirizzata altrove.
 */
export const silentCheckSsoRedirectUri = (): string => {
  return `${window.location.origin}${Config.baseHref}/assets/silent-check-sso.html`;
};

/** Configurazione del server letta una volta sola da `config.json` e tenuta in memoria per le letture successive. */
export const getSettingsAsync = async (): Promise<KeycloakServerConfig> => {
  if (settings == null) {
    const config = await getConfigAsync();
    if (config) {
      settings = config.sso;
    }
  }
  return settings as KeycloakServerConfig;
};
